import { PatternType } from "../../gamma-engine/slots/model/SlotMachineDescription";

export const REEL_DATA = {
    regular: {
        cascading: true,
        reels: [
            {
                numRows: 7,
                availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
            },
            {
                numRows: 7,
                availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
            },
            {
                numRows: 7,
                availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
            },
            {
                numRows: 7,
                availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
            },
            {
                numRows: 7,
                availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
            },
            {
                numRows: 7,
                availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
            },
            {
                numRows: 7,
                availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
            }
        ]
    },
    freeSpins: [
        {
            id: 0,
            cascading: true,
            reels: [
                {
                    numRows: 7,
                    availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
                },
                {
                    numRows: 7,
                    availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
                },
                {
                    numRows: 7,
                    availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
                },
                {
                    numRows: 7,
                    availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
                },
                {
                    numRows: 7,
                    availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
                },
                {
                    numRows: 7,
                    availableSymbols: [25, 104, 103, 102, 101, 203, 202, 201],
                }
            ]
        },
    ]
};

export const RULES = [
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [5],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.2
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [6],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.25
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [7],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.3
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [8],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.4
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [9],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [10],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [11],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [12],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 2.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [13],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [14],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 10
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 104,
            symbolCount: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 20
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [5],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.25
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [6],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.3
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [7],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.4
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [8],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [9],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.75
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [10],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.25
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [11],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 2
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [12],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 3
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [13],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 6
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [14],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 12
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 103,
            symbolCount: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 25
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [5],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.3
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [6],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.4
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [7],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [8],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.75
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [9],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [10],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [11],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 2.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [12],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 3.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [13],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 8
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [14],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 15
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 102,
            symbolCount: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 30
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [5],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.4
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [6],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [7],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.75
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [8],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [9],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.25
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [10],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 2
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [11],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 3
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [12],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [13],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 10
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [14],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 20
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 101,
            symbolCount: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 40
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [5],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [6],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [7],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.75
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [8],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 2
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [9],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 2.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [10],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [11],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 7.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [12],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 15
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [13],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 35
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [14],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 70
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 201,
            symbolCount: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 150
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [5],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.75
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [6],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [7],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.25
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [8],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [9],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 2
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [10],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 4
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [11],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 6
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [12],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 12.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [13],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 30
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [14],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 60
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 202,
            symbolCount: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 100
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [5],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [6],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 0.75
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [7],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [8],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.25
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [9],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 1.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [10],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 3
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [11],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 4.5
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [12],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 10
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [13],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 20
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [14],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 40
            }
        }
    },
    {
        id: 0,
        pattern: {
            symbolId: 203,
            symbolCount: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            type: PatternType.BOTH_WAYS
        },
        reward: {
            line: {
                multiplier: 60
            }
        }
    }
];

export const LOGIN_CURRENT = {
    TotalWin: 0,
    AccWin: 0,
    MultiplierMap: {},
    Result: {
        R: "102,102,201,103,202,102,104|101,103,101,102,201,101,101|104,201,104,201,201,202,202|202,203,203,104,201,101,101|104,203,203,102,102,202,102|203,101,201,201,102,101,101|101,101,103,103,103,203,203",
        clusterDetails: []
    },
    Round: {
        RoundType: 1,
        Bet: 1,
        BetValue: 1,
        Line: 20,
        LineBet: 0.2,
        Payout: 0
    },
    Type: 1,
    FreeSpin: null,
    Bonus: null,
};

export const ERROR_CONSTANTS = {
    BET_AMOUNT_NOT_IN_LIMIT: 'BET_AMOUNT_NOT_IN_LIMIT',
    INVALID_ROUND_ID: "INVALID_ROUND_ID",
    INVALID_GAME : "INVALID_GAME",
    ROUND_NOT_FINISHED: "ROUND_NOT_FINISHED",
    INVALID_SESSION: "INVALID_SESSION",
}

export const GAME_NAME = 'jewelOfWizard';

export const FORCING_DATA = ["buyFeatureMaxWin", "maxWin"];

export const BUY_FEATUE_MAX_WIN = "buyFeatureMaxWin"

export const MAX_WIN = "maxWin"